/**
 * Feature Access Context
 *
 * Context definition and types for feature access checking
 * Provider component is in FeatureAccessProvider.tsx to follow
 * Vite Fast Refresh rule: export either types OR components, not both
 */

import React from "react";
import type { Plan, Feature } from "../types/plan";

/**
 * Feature access context type
 */
export interface FeatureAccessContextType {
  /** Check if user has access to a specific feature */
  hasFeature: (featureId: string) => boolean;
  /** Get the user's current plan */
  userPlan: Plan | null;
  /** Get all features accessible to the user */
  accessibleFeatures: Feature[];
  /** Get all inaccessible features */
  inaccessibleFeatures: Feature[];
  /** Whether feature data is still loading */
  loading: boolean;
  /** Error state */
  error: unknown;
}

/**
 * Feature access context
 */
export const FeatureAccessContext = React.createContext<
  FeatureAccessContextType | undefined
>(undefined);

// Provider lives in FeatureAccessProvider.tsx
